if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

       const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
       let productInfoElement = this.form.closest("product-info");

        let selectedIds = [];
        let idInput = this.form.querySelector("input[name='id']");
        let quantityInput = this.form.querySelector("input[name='quantity']");
        
        if (idInput) {
          selectedIds.push({
            id: formData.get("id"), // Get main product ID
            quantity: parseInt(formData.get("quantity")) || 1, // Get quantity (default: 1)
          });
        }
        
        setTimeout(() => {
          if (productInfoElement) {
            let selectedUpsellElements = productInfoElement.querySelectorAll(
              "product-info-upsell[data-selected='true']"
            );
        
            selectedUpsellElements.forEach((upsellElement) => {
              let productForm = upsellElement.querySelector("product-form form");
              if (productForm) {
                let idInput = productForm.querySelector("input[name='id']");
                if (idInput) {
                  selectedIds.push({
                    id: idInput.value,
                    quantity: 1, // Default quantity for upsell items
                  });
                }
              }
            });
          }
        
          // Merge duplicate product IDs by summing their quantities
          let mergedItems = selectedIds.reduce((acc, item) => {
            let existing = acc.find((p) => p.id === item.id);
            if (existing) {
              existing.quantity += item.quantity; // Increase quantity if already exists
            } else {
              acc.push({ ...item }); // Add new product entry
            }
            return acc;
          }, []);
        
          // Clear old data
          formData.delete("id");
          formData.delete("quantity");
        
          // Use correct Shopify format
          mergedItems.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
        
          console.log([...formData.entries()]); // Debugging output
          config.body = formData;


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
console.log(response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.getAll('id[]'),
                quantity: formData.getAll('quantity[]'), // Ensure all quantities are sent
                errors: response.errors || response.description,
                message: response.message,
              });
              
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const cartIconBubbleElement = document.getElementById('cart-icon-bubble');
            if(cartIconBubbleElement){
              if(response.sections['cart-icon-bubble']){
                const tempDivresponse = document.createElement('div');
                tempDivresponse.innerHTML = response.sections['cart-icon-bubble'];
                const svgElementresponse = tempDivresponse.querySelector('svg');
                const imgElementresponse = tempDivresponse.querySelector('img');
                const cartCountBubbleElement = tempDivresponse.querySelector('.cart-count-bubble');
                const svgContainer = document.getElementById("cart-icon-bubble");
                const svgElement = svgContainer.querySelector("svg");
                const imgElement = svgContainer.querySelector("img");
                if (svgElementresponse) {
                    if(svgElement){
                      svgElementresponse.innerHTML = svgElement.innerHTML;
                    }
                    if (imgElement) {
                        svgElementresponse.outerHTML = `<img id="Outline" src="${imgElement.src}" alt="">`; // Replace with <img>
                    }
                } else if (imgElementresponse) {
                   if(svgElement){
                     svgElementresponse.innerHTML = svgElement.innerHTML;
                   }
                } 
                response.sections['cart-icon-bubble'] = tempDivresponse.innerHTML;
              }
            }

            

            // this.error = (this.error !== undefined && this.error) || false;
            
            // if (!this.error) {
            //   console.log('Publishing cartUpdate event');
            //   publish(PUB_SUB_EVENTS.cartUpdate, {
            //     source: 'product-form',
            //     productVariantId: formData.get('id'),
            //     cartData: response,
            //   });
            // }
            // this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
                var cartCountElement = document.querySelector('.cart-count-bubble');
                var parentElement = document.getElementById('cart-icon-bubble');
                if (cartCountElement && parentElement) {
                  var newDiv = document.createElement('div');
                  newDiv.classList.add('main_cart_bubble_count');
                  newDiv.appendChild(cartCountElement);
                  parentElement.appendChild(newDiv);
                  var mainCartBubbleCount = document.querySelector('.main_cart_bubble_count');
                  var hiddenSpan = mainCartBubbleCount.querySelector('.cart-count-bubble span[aria-hidden="true"]');
                  if (hiddenSpan) {
                    hiddenSpan.parentElement.removeChild(hiddenSpan);
                    mainCartBubbleCount.appendChild(hiddenSpan);
                  }
                }
  
              const skipCartField = document.querySelector('input.product-variant-id[data-skip-cart="true"]');
              if (skipCartField) {
                  window.location.href = '/checkout';
              }
  
            });
          }, 100); 
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
